import Template from '../../component/Template.js';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import Select from 'react-select'; //04-03-2024-multiselect

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Api from '../../component/Api.js';
import { Link } from 'react-router-dom';
import React, { useRef } from "react";

import 'datatables.net';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import $ from 'jquery';
import Group from '@mui/icons-material/Group';
import CheckCircle from '@mui/icons-material/CheckCircle';
import RemoveCircleOutline from '@mui/icons-material/RemoveCircleOutline';



export default function InternshipList() {

  const [internshipData, setInternshipData] = useState([]);
  const [internshipDataID, setInternshipDataID] = useState(null);

  const [flag, setflag] = useState(false);
  const [issaved, setissaved] = useState(false);


  const tableRef = useRef(null);

  {/*------------------------------------*/ }
  /* CUSTOM DATA TABLE BEGIN HERE */
  const [tableData, setTableData] = useState([]);


  const [sortBy, setSortBy] = useState({ column: null, direction: 'asc' }); //sort
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredAndSortedData, setfilteredAndSortedData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [total_count, setTotal] = useState(null);
  const [loading, setlodaing] = useState(false);

  const [reload, setReload] = useState(false);
  const [disciplinedata, setDisciplineData] = useState([]);
  const [disciplineId, setDisciplineId] = useState(null);
  const [disciplinetype, setDisciplineTypeChange] = useState(null);
  const [collegedisciplinetype, setCollegeDisciplineTypeChange] = useState(null);

  const [disciplineName, setDisciplineNameChange] = useState(null);
  const [getConfirm, setConfirm] = useState(false);
  const [rejectConfirm, setRejectConfirm] = useState(false);
  const [getInternshipCount, setInternshipCount] = useState([]);



  /* CUSTOM DATA TABLE END HERE */


  const { http } = Api();
  const navigate = useNavigate();

  const isAuth = useAuth();
  if (isAuth === false) {
    navigate("/college/");
  }


  let cid = localStorage.getItem("collegeid");
  let collegename = localStorage.getItem("username");

  useEffect(() => {
    const internshipData = async () => {
      try {
        const response = await http.post('College/listTopic', {

          searchDiscipline: disciplineId || null,

        });

        setInternshipData(response.data.data || []);
      } catch (error) {
        console.error("Error fetching internship data");
        toast.error("Error fetching internship data:");
      }
    };
    internshipData();


  }, [issaved, reload, disciplineId]);
  console.log("disciplineId", disciplineId)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await http.get(`/College/getCollegeDisciplinesfor_SFA_DEO_Panel`, {
          params: {
            limit: '500',
            college_id: cid
          }
        });

        //setDisciplineData(response.data);
        // Check if data is an array
        if (Array.isArray(response.data)) {
          setDisciplineData(response.data);
        } else {
          setDisciplineData([]); // fallback to empty array
        }
      }
      catch (error) {
        if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
          toast.error("Invalid Token");
          setTimeout(() => {
            navigate("/college/");
          }, 5000);

        }
        else if (error.response.data.http_status === 429 && error.response.data.status_code == "ERR33") {
          toast.error(error.response.data.message);
        }
        else {
          toast.error("Something went wrong");
        }
      }
    };

    fetchData();
  }, [reload, cid]);


  const handleDisciplineChange = (selectedOption) => {
    console.log("ok");

    if (selectedOption) {
      setDisciplineId(selectedOption.did);
      setDisciplineNameChange(selectedOption.value);
      setDisciplineTypeChange(selectedOption.type);
      setCollegeDisciplineTypeChange(selectedOption.college_discipline_id);
      console.log("disciplineId==", selectedOption.did);
    }
    else {
      setDisciplineId(null);
      setDisciplineNameChange(null);
      setDisciplineTypeChange(null);
      setCollegeDisciplineTypeChange(null);
    }
  };

  /* DATA TABLE  */

  const handleSearchInputChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleSort = (column) => {
    const newSortBy = {
      column,
      direction: sortBy.column === column && sortBy.direction === 'asc' ? 'desc' : 'asc',
    };
    setSortBy(newSortBy);
  };


  useEffect(() => {
    const filteredAndSortedData = [...internshipData]
      .filter(item => {
        const text = searchQuery.toLowerCase();

        const searchableText = [
          item.internship_topic,
          item.offered_by_name,
          item.mode_of_study,
          String(item.total_seats),
          item.approve_status,
          //disciplines data  
          item.disciplines?.map(d => d.discipline_name).join(" ")
        ]
          .filter(Boolean)   // remove null/undefined
          .join(" ")         // merge into one string
          .toLowerCase();

        return searchableText.includes(text);
      })
      .sort((a, b) => {
        if (!sortBy.column) return 0;

        let valA = a[sortBy.column];
        let valB = b[sortBy.column];

        // special handling for disciplines
        if (sortBy.column === "discipline_name") {
          valA = a.disciplines?.map(d => d.discipline_name).join(", ") || "";
          valB = b.disciplines?.map(d => d.discipline_name).join(", ") || "";
        }

        if (typeof valA === "string") valA = valA.toLowerCase();
        if (typeof valB === "string") valB = valB.toLowerCase();

        if (sortBy.direction === "asc") {
          return valA > valB ? 1 : -1;
        } else {
          return valA < valB ? 1 : -1;
        }
      });

    const itemsPerPage = 50;
    const startIndex = (currentPage - 1) * itemsPerPage;
    const paginatedData = filteredAndSortedData.slice(startIndex, startIndex + itemsPerPage);

    setfilteredAndSortedData(paginatedData);
    setTotalPages(Math.ceil(filteredAndSortedData.length / itemsPerPage));
    setTotal(filteredAndSortedData.length);

  }, [searchQuery, sortBy, internshipData, currentPage]);

  const renderSortIcon = (columnName) => {
    if (sortBy.column === columnName) {
      return sortBy.direction === 'asc' ? <i className="fa fa-sort-up ml-1" aria-hidden="true"></i> : <i className="fa fa-sort-down ml-1" aria-hidden="true"></i>;
    }
    return <i className="fa fa-sort ml-1" aria-hidden="true"></i>; // Show disabled sort icon
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  /* DATA TABLE END */

  useEffect(() => {

    const getInternshipTopicCounts = async () => {

      try {
        const response = await http.get('/College/InternshipTopicCounts');

        setInternshipCount(response.data);


      } catch (error) {

        setInternshipCount([]);
        if (error.response.data.http_status === 500 && error.response.data.status_code == "ERR47") {
          toast.error(error.response.data.message);
        }
        else {
          console.error('Error fetching statistics:', error);
          toast.error('Error fetching statistics');
        }

      }
    };



    getInternshipTopicCounts();


  }, []);

  const handleGeneratePDFNew = async () => {
    // setLoading(true);
    try {
      const response = await http.get('/College/topicListpdfDownload', {
        params: {
          college_id: cid,
          user_type: 22
        },
        responseType: 'blob', // Expect binary response
      });

      if (response && response.data) {
        // Create a URL for the downloaded file
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;

        // Set the file name and download the PDF
        link.setAttribute(
          'download',
          `${localStorage.getItem('username')}_${collegename}_InternshipList.pdf`
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // setLoading(false);
        toast.success('PDF generated successfully');
      }
    } catch (error) {
      //console.log("error",error);
      // setLoading(false);
      if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
        toast.error("Invalid Token");
        setTimeout(() => {
          navigate("/college/");
        }, 5000);

      }
      else if (error.response.data.http_status === 500 && error.response.data.status_code == "ERR47") {
        toast.error(error.response.data.message);
      }
      else {
        console.error('Error generating PDF:', error);
        toast.error('Error generating PDF');
      }
    }
  };


  const handleClearFields = () => {
    setDisciplineId(null);
    setDisciplineData([]);
    setDisciplineTypeChange(null);
    setReload(!reload);


  }
  const showConfirm = (id) => {
    setInternshipDataID(id);
    setConfirm(true);
  }
  const showRejectConfirm = (id) => {
    setInternshipDataID(id);
    setRejectConfirm(true);
  }

  const handleCancel = () => {
    setConfirm(false);
  }

  const handleRejectCancel = () => {
    setRejectConfirm(false);
  }

  const handleApprove = () => {

    http.post('/College/Principalforward', {
      id: internshipDataID
    })
      .then((response) => {

        if (response.data.status_code === 'MSG3') {
          setissaved(!issaved);
          setConfirm(false);

          toast.success('Topic Forwarded Successfully');
        }
        else {
          setissaved(!issaved);
          toast.error('Failed to save data');
        }

      })
      .catch((error) => {
        setissaved(!issaved);
        setConfirm(false);

        const status = error.response?.data?.http_status;
        const message = error.response?.data?.message || "An error occurred";

        if (status === 500 || error.response?.data?.status_code === "ERR5") {
          toast.error(message);
        }
        else if (status === 403 && error.response?.data?.status_code === "ERR37") {
          toast.error("Invalid Token");
          setTimeout(() => navigate("/ino/"), 5000);
        }
        else {
          toast.error("Something went wrong");
        }
      });
  };
  const handleReject = () => {

    http.post('/College/Principalrevert', {
      id: internshipDataID
    })
      .then((response) => {

        if (response.data.status_code === 'MSG3') {
          setissaved(!issaved);
          setRejectConfirm(false);

          toast.success('Topic Reverted Successfully');
        }
        else {
          setissaved(!issaved);
          toast.error('Failed to revert');
        }

      })
      .catch((error) => {
        setissaved(!issaved);
        setRejectConfirm(false);


        const status = error.response?.data?.http_status;
        const message = error.response?.data?.message || "An error occurred";

        if (status === 500 || error.response?.data?.status_code === "ERR5") {
          toast.error(message);
        }
        else if (status === 403 && error.response?.data?.status_code === "ERR37") {
          toast.error("Invalid Token");
          setTimeout(() => navigate("/ino/"), 5000);
        }
        else {
          toast.error("Something went wrong");
        }
      });
  };




  const customStyles = {
    menu: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
      textAlign: 'left', // added

    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '180px',
      overflowY: 'auto',
      scrollbarWidth: 'thin',
      scrollbarColor: '#888 #f1f1f1',
      textAlign: 'left', // added

    }),

    multiValue: (provided) => ({
      ...provided,
      '&::-webkit-scrollbar': {
        width: '8px',
        textAlign: 'left', // added

      },
      '&::-webkit-scrollbar-track': {
        background: '#f1f1f1',
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#888',
        borderRadius: '4px',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: '#555',
      },
    }),
  };

  return (
    <>
      <ToastContainer />
      <Template>
        <div className="container-fluid">
          <div className="row">
            <div className="table-responsive">
              <div className="card">
                <div className="col-md-12">
                  <div className="card-header">
                    <div className="py-3 d-flex justify-content-between align-items-center">
                      <h5>Internship Topic List</h5>
                    </div>
                  </div>
                  <div className="card-body">
                    {/* <div className="table-responsive"> */}


                    <div className="table-responsive">

                      <div className="row align-items-center pdg18">
                        {/* Left 6 columns */}
                        <div className="col-md-8">
                          {/* <div className="row align-items-center">
                            <div className="col-md-6">
                              <label>Department/Discipline</label>
                              <Select
                                maxMenuHeight={200}
                                menuPlacement="auto"
                                id="discipline_id"
                                name="discipline_id"
                                className="form"
                                placeholder="Select Department/Discipline"
                                isSearchable={true}
                                isClearable={true}
                                styles={customStyles}
                                onChange={handleDisciplineChange}
                                options={flag
                                  ? [{ value: '0', label: 'No data found' }]
                                  : disciplinedata
                                    .sort((a, b) => a.discipline_name.localeCompare(b.discipline_name))
                                    .map(disciplines => ({
                                      did: disciplines.discipline_id,
                                      value: disciplines.discipline_name,
                                      label: disciplines.college_discipline_id == 1
                                        ? `${disciplines.discipline_name} (Single Faculty Course)`
                                        : disciplines.discipline_name,
                                      type: disciplines.college_course_type,
                                      college_discipline_id: disciplines.college_discipline_id
                                    }))
                                }
                                value={
                                  disciplinedata
                                    .map(d => ({
                                      did: d.discipline_id,
                                      value: d.discipline_name,
                                      label: d.college_discipline_id == 1
                                        ? `${d.discipline_name} (Single Faculty Course)`
                                        : `${d.discipline_name}`,
                                      type: d.college_course_type,
                                      college_discipline_id: d.college_discipline_id
                                    }))
                                    .find(option => option.did == disciplineId && option.type == disciplinetype) || null
                                }
                              />
                            </div>

                            <div className="col-md-6 d-flex align-self-end">
                              <button
                                type="button"
                                className="btn btn-secondary clear-btn ms-2"
                                onClick={handleClearFields}
                              >
                                Clear
                              </button>
                            </div>
                          </div> */}
                        </div>

                        {/* Right 6 columns */}
                        <div className="col-md-4 d-flex justify-content-end">
                          <div className="d-flex gap-2">
                            {/* <Link
                              className="btn custom-btn btn-primary common-btn d-inline-flex align-items-center justify-content-center"
                              to="/college/addusers"
                              title="Add New User"
                            >
                              <i className="bi bi-plus-square ctm-btn-sz m-r-5"></i>New
                            </Link> */}



                            <button
                              className="btn btn-primary common-btn d-inline-flex align-items-center justify-content-center pdf-btn"
                              onClick={() => handleGeneratePDFNew()}
                              title="Download to PDF"
                            >
                              <i className="bi bi-arrow-down-square ctm-btn-sz"></i>
                            </button>

                          </div>
                        </div>
                      </div>


                      <div className="container">
                        <div className="table-responsive ovrflw" style={{ overflowX: 'auto' }}>
                          <div className="row justify-content-center">
                            <div className="col-md-10 stat-out-bod">
                              <table
                                className="table-striped table-bordered ex-table mb-10"
                                ref={tableRef}
                                id="dataTableBos"
                                width="100%"
                                style={{ textAlign: 'center', tableLayout: 'fixed' }}
                              >
                                <thead>
                                  <tr className="col-cnt-tab-bg-clr" style={{ height: '40px' }}>

                                    <th style={{ textAlign: "center", verticalAlign: "middle", width: '50%' }}>
                                      Total Topics
                                    </th>
                                    <th style={{ textAlign: "center", verticalAlign: "middle", width: '50%' }}>
                                     Forward Pending
                                    </th>
                                    <th style={{ textAlign: "center", verticalAlign: "middle", width: '50%' }}>
                                      Reverted
                                    </th>
                                    <th style={{ textAlign: "center", verticalAlign: "middle", width: '50%' }}>
                                      Forwarded to Principal
                                    </th>

                                    <th style={{ textAlign: "center", verticalAlign: "middle", width: '50%' }}>
                                      Approved by Principal
                                    </th>
                                  </tr>

                                </thead>
                                <tbody>
                                  <tr>
                                    <td>{getInternshipCount?.total_topics ? getInternshipCount.total_topics : '0'}</td>
                                    <td>{getInternshipCount?.entered_count ? getInternshipCount.entered_count : '0'}</td>
                                    <td>{getInternshipCount?.revert_count ? getInternshipCount.revert_count : '0'}</td>
                                    <td>{getInternshipCount?.forwarded_to_principal ? getInternshipCount.forwarded_to_principal : '0'}</td>
                                    <td>{getInternshipCount?.forwarded_to_university ? getInternshipCount.forwarded_to_university : '0'}</td>


                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='row'>

                        <div className='col-md-6 wdt' >
                          <p>
                            Showing {(currentPage - 1) * 50 + 1}{''}-
                            {Math.min((currentPage - 1) * 50 + 50, total_count)} of {total_count} entries
                          </p>
                        </div>
                        <div className='col-md-6 wdt' align='right'>
                          <input
                            type="text"
                            value={searchQuery}
                            onChange={handleSearchInputChange}
                            placeholder="Search..."
                            className='form-control'
                          /></div></div>
                      <div class="table-containerq" style={{ overflowX: 'unset' }}>

                        <table className="display dataTable table-striped table-bordered ex-v-table " ref={tableRef}>
                          <thead>
                            <tr className="bg-primary">

                              <th onClick={() => handleSort('sl_no')} scope="col" width="6%">
                                SL NO &nbsp; {renderSortIcon('sl_no')}
                              </th>

                              <th onClick={() => handleSort('offered_by_name')} scope="col">
                                Offered By &nbsp; {renderSortIcon('offered_by_name')}
                              </th>

                              <th onClick={() => handleSort('internship_topic')} scope="col">
                                Internship Topic &nbsp; {renderSortIcon('internship_topic')}
                              </th>

                              <th onClick={() => handleSort('discipline_name')} scope="col">
                                Disciplines &nbsp; {renderSortIcon('discipline_name')}
                              </th>

                              {/* <th onClick={() => handleSort('internal')} scope="col" className="text-center">
                                Internal &nbsp; {renderSortIcon('internal')}
                              </th>

                              <th onClick={() => handleSort('external')} scope="col" className="text-center">
                                External &nbsp; {renderSortIcon('external')}
                              </th> 

                              <th onClick={() => handleSort('total_seats')} scope="col" className="text-center">
                                Total Seats&nbsp; {renderSortIcon('total_seats')}
                              </th>*/}

                              <th onClick={() => handleSort('mode_of_study')} scope="col">
                                Mode of Study &nbsp; {renderSortIcon('mode_of_study')}
                              </th>
                              <th scope="col" className="text-center">
                                Status
                              </th>
                              <th scope="col" className="text-center">
                                Action
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {filteredAndSortedData.length > 0 ? (
                              filteredAndSortedData.map((item, index) => (
                                <tr key={item.id}>
                                  <td>{(currentPage - 1) * 50 + index + 1}</td>
                                  <td>{item.offered_by_name}</td>
                                  <td>{item.internship_topic}</td>
                                  <td>
                                    {item.disciplines?.length
                                      ? item.disciplines.map(d => d.discipline_name).join(', ')
                                      : '-'}
                                  </td>
                                  {/* <td className="text-center">{item.internal_seats}</td>
                                  <td className="text-center">{item.external_seats}</td> 
                                  <td className="text-center">{item.total_seats}</td>*/}
                                  <td className="text-center">{item.mode_of_study}</td>
                                  <td>
                                    {item.approve_status === "" || item.approve_status === null ? (
                                      <span className="badge bg-warning text-dark">Pending</span>
                                    ) : item.approve_status === "forwarded to principal" ? (
                                      <span className="badge bg-blue-clr">Forwarded to Principal</span>
                                    ) : item.approve_status === "forwarded to university" ? (
                                      <span className="badge bg-success">Principal Approved</span>
                                    ) :
                                      item.approve_status === "revert" ? (
                                        <span className="badge bg-danger">Principal Reverted</span>
                                      ) :
                                        (
                                          <span className="badge bg-secondary">N/A</span>
                                        )}
                                  </td>

                                  <td>
                                    <div className="d-flex gap-3 justify-content-center int-action-icons">

                                      {item.approve_status === "forwarded to university" ? (
                                        <i
                                          className="bi bi-check2-all int-forward-icon icn-out-bod"
                                          title="Already Principal Approved"
                                          onClick={() => toast.info("Already forwarded")}
                                          style={{ opacity: 0.6, cursor: "not-allowed" }}
                                        ></i>
                                      ) : item.approve_status !== "" && item.approve_status !== null && item.approve_status === "forwarded to principal" ? (

                                        <i
                                          className="bi bi-check2-all int-forward-icon icn-out-bod"
                                          title="Approve"
                                          onClick={() => showConfirm(item.id)}
                                        ></i>
                                      ) : null}

                                      {item.approve_status === "revert" ? (
                                        <i
                                          className="bi bi-arrow-counterclockwise int-reject-icon icn-out-bod"
                                          title="Already reverted"
                                          onClick={() => toast.info("Already reverted")}
                                          style={{ opacity: 0.6, cursor: "not-allowed" }}
                                        ></i>
                                      ) :
                                        item.approve_status !== "" && item.approve_status !== null && item.approve_status === "forwarded to principal" ? (

                                          <i
                                            className="bi bi-arrow-counterclockwise int-reject-icon icn-out-bod"
                                            title="Revert"
                                            onClick={() => showRejectConfirm(item.id)}
                                          ></i>
                                        ) : null}

                                    </div>
                                  </td>


                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="9" className="text-center">No data found</td>
                              </tr>
                            )}
                          </tbody>

                        </table>
                      </div>

                      {totalPages > 1 && (
                        <nav aria-label="..." style={{ cursor: "pointer" }}>
                          <ul className="pagination justify-content-center">
                            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                              <span className="page-link pgn-clr" onClick={handlePreviousPage}><i class="bi bi-arrow-left-circle-fill"></i></span>
                            </li>
                            <li className={`page-item`}>
                              <span className="page-link pgn-clr" onClick={() => handlePageChange(1)}>1</span>
                            </li>
                            {currentPage > 4 && <li className="page-item"><span className="page-link pgn-clr">...</span></li>}
                            {[...Array(totalPages - 1).keys()].slice(currentPage > 4 ? currentPage - 3 : 1, currentPage + 2).map((pageNumber) => (
                              <li key={pageNumber} className={`page-item ${pageNumber + 1 === currentPage ? 'act-clr' : ''}`}>
                                <span className="page-link pgn-clr" onClick={() => handlePageChange(pageNumber + 1)}>{pageNumber + 1}</span>
                              </li>
                            ))}
                            {currentPage < totalPages - 3 && <li className="page-item"><span className="page-link pgn-clr">...</span></li>}

                            <li className={`page-item`}>
                              <span className="page-link pgn-clr" onClick={() => handlePageChange(totalPages)}>{totalPages}</span>
                            </li>

                            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                              <span className="page-link pgn-clr" onClick={handleNextPage}><i class="bi bi-arrow-right-circle-fill"></i></span>
                            </li>
                          </ul>
                        </nav>
                      )}


                      {/*  Delete User */}
                      <div className={`modal fade show ${getConfirm ? 'd-block' : ''}`} id="exampleModalCenter1" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenter1" aria-model="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                          <div className="modal-content">
                            <div className="modal-body">
                              <div className="modal-toggle-wrapper">
                                {/* <ul className="modal-img">
                                  <li> <img src={logo} /></li>
                                </ul> */}
                                <h4 className="text-center pb-2">Are you sure you want to approve this topic?</h4>
                                <p className="text-center">This action cannot be undone.Please confirm to proceed and forward the topic to the university.</p>
                                <div className="d-flex justify-content-center mt-3">
                                  <button className="btn btn-danger mx-2" onClick={() => handleApprove()}>Confirm Approve</button>
                                  <button className="btn " style={{ backgroundColor: 'white', borderColor: 'red', color: 'black' }} data-bs-dismiss="modal" onClick={() => handleCancel()}>Cancel</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/*  Delete User End */}

                      <div className={`modal fade show ${rejectConfirm ? 'd-block' : ''}`} id="exampleModalCenter1" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenter1" aria-model="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                          <div className="modal-content">
                            <div className="modal-body">
                              <div className="modal-toggle-wrapper">
                                {/* <ul className="modal-img">
                                  <li> <img src={logo} /></li>
                                </ul> */}
                                <h4 className="text-center pb-2">Are you sure you want to revert this topic?</h4>
                                <p className="text-center">This action cannot be undone. Please confirm to proceed.</p>
                                <div className="d-flex justify-content-center mt-3">
                                  <button className="btn btn-danger mx-2" onClick={() => handleReject()}>Confirm Revert</button>
                                  <button className="btn " style={{ backgroundColor: 'white', borderColor: 'red', color: 'black' }} data-bs-dismiss="modal" onClick={() => handleRejectCancel()}>Cancel</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>




                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>



      </Template>
    </>
  );
}
